// SPDX-License-Identifier: Apache-2.0
"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnclaveWSProvider = exports.UninitializedConn = void 0;
const isomorphic_ws_1 = __importDefault(require("isomorphic-ws"));
exports.UninitializedConn = "uninitialized connection";
/**
 * Implementation of an EnclaveProvider over a websocket connection.
 */
class EnclaveWSProvider {
    constructor(url) {
        this.url = url.toString();
        this.onopen = null;
        this.onclose = null;
        this.onerror = null;
        this.onmessage = null;
        this.initialized = false;
    }
    connect() {
        this.close();
        this.ws = new isomorphic_ws_1.default(this.url);
        this.ws.onmessage = this.onmessage;
        this.ws.onerror = this.onerror;
        this.ws.onopen = (e) => {
            this.initialized = true;
            if (this.onopen)
                this.onopen(e);
        };
        this.ws.onclose = this.onclose;
    }
    close() {
        if (!this.ws) {
            return;
        }
        this.ws.close();
        this.ws = null;
        this.initialized = false;
    }
    send(data) {
        if (!this.initialized) {
            throw new Error(exports.UninitializedConn);
        }
        this.ws.send(data);
    }
}
exports.EnclaveWSProvider = EnclaveWSProvider;
//# sourceMappingURL=provider.js.map